import React, { useState, useEffect } from 'react';
import './UserProfile.css';

interface UserProfileProps {
  onClose: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({ onClose }) => {
  const [profile, setProfile] = useState({
    name: '',
    company: 'Sesam SARL',
    phone: '',
    position: 'Chef de projet'
  });

  useEffect(() => {
    const saved = localStorage.getItem('userProfile');
    if (saved) {
      setProfile(JSON.parse(saved));
    }
  }, []);

  const handleSave = () => {
    localStorage.setItem('userProfile', JSON.stringify(profile));
    onClose();
  };

  return (
    <div className="user-profile-modal" onClick={onClose}>
      <div className="profile-content" onClick={(e) => e.stopPropagation()}>
        <h2>👤 Profil Utilisateur</h2>
        
        <div className="form-group">
          <label>Nom complet</label>
          <input
            type="text"
            value={profile.name}
            onChange={(e) => setProfile({...profile, name: e.target.value})}
            placeholder="Ex: Jean Dupont"
          />
        </div>

        <div className="form-group">
          <label>Entreprise</label>
          <input
            type="text"
            value={profile.company}
            onChange={(e) => setProfile({...profile, company: e.target.value})}
            placeholder="Ex: Sesam SARL"
          />
        </div>

        <div className="form-group">
          <label>Téléphone</label>
          <input
            type="text"
            value={profile.phone}
            onChange={(e) => setProfile({...profile, phone: e.target.value})}
            placeholder="Ex: +41 22 123 45 67"
          />
        </div>

        <div className="form-group">
          <label>Poste</label>
          <input
            type="text"
            value={profile.position}
            onChange={(e) => setProfile({...profile, position: e.target.value})}
            placeholder="Ex: Chef de projet"
          />
        </div>

        <div className="profile-actions">
          <button onClick={onClose} className="btn-cancel">Annuler</button>
          <button onClick={handleSave} className="btn-save">✓ Enregistrer</button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
